import { GetterTree } from 'vuex'
import { split, head, last, pipe, filter, lowerCase } from 'lodash/fp'

import type { TechpackState } from './techpack.types'

const supportedPreviews = ['jpg', 'jpeg', 'jfif', 'pjpeg', 'pjp', 'png', 'svg', 'pdf']

const getFileExtension = pipe(split('?'), head, split('.'), last, lowerCase)

const canPreview = (attachment: any): boolean => {
  const fileExtension = getFileExtension(attachment.link)
  return supportedPreviews.some(ext => ext === fileExtension)
}

const filterPreviewable = filter(canPreview)
const filterNonPreviewable = filter((att: unknown) => !canPreview(att))

export const getters: GetterTree<TechpackState, unknown> = {
  getTechpack(state) {
    return state.techpack
  },
  getTechpackShareAttachmentsPreview(state) {
    return filterPreviewable(state.techpack?.attachments)
  },
  getTechpackShareAttachmentsNonPreview(state) {
    return filterNonPreviewable(state.techpack?.attachments)
  }
}
